import { useDispatch } from "react-redux";
import { AppDispatch, RootState } from "../../store";
import { useSelector } from "react-redux";
import useDropdown from "../../util/hooks/useDropDown";
import { dropDown, location } from "../../asset";
import { setLocalStorage } from "../../util/manageStorage";
import { fetchStaffAccess } from "../../features/access-controller/AccessController";


export default function BranchSelector({
  showLogo = false,
  logoUrl,
}: {
  showLogo?: boolean;
  logoUrl?: string;
}) {
  const dispatch = useDispatch<AppDispatch>();

  const userId = useSelector((state: RootState) => state.user.user?.userId);
  const schoolBranch = useSelector(
    (state: RootState) => state.access.schoolBranch,
  );
  const allBranches = useSelector(
    (state: RootState) => state.access.allBranches,
  );

  const {
    isOpen,
    toggleDropdown,
    dropdownRef,
  } = useDropdown(false);

  return (
    <div className="relative flex items-center md:gap-11" ref={dropdownRef}>
      <div
        className="flex items-center gap-3 cursor-pointer"
        onClick={toggleDropdown}
      >
       
        {/* {showLogo && logoUrl && (
          <img src={logoUrl} alt="logo" className="w-20 xl:hidden" />
        )} */}

        <div className="flex items-center gap-2 md:gap-4">
          <img src={location} alt="location" className="w-4 h-4" />
          <span className="text-sm font-medium text-neutral-500">
            {schoolBranch?.schoolBranchCode} -{" "}
            {schoolBranch?.schoolBranchName}
          </span>

          {allBranches?.length > 1 && (
            <img
              src={dropDown}
              alt="dropdown"
              className={`w-3 h-3 transition-transform ${
                isOpen ? "rotate-180" : ""
              }`}
            />
          )}
        </div>
      </div>

      {isOpen && allBranches?.length > 1 && (
        <div className="absolute top-10 left-0 bg-white shadow-lg rounded-lg border w-full z-50">
          {allBranches.map((branch) => (
            <div
              key={branch.schoolBranchId}
              onClick={() => {
                if (!userId) return;

                setLocalStorage(
                  "selectedBranchCode",
                  branch.schoolBranchCode,
                );

                dispatch(
                  fetchStaffAccess({
                    userId,
                    branchCode: branch.schoolBranchCode,
                  }),
                );

                window.location.reload(); 
              }}
              className="px-4 py-2 hover:bg-background-200 text-start cursor-pointer text-sm"
            >
              {branch.schoolBranchCode} - {branch.schoolBranchName}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
